import { apiPost } from "./api";

export default class ServicioMuestras {
  static getInfoCita(citaPersonaID) {
    return apiPost("/muestras/ObtenerInfoCita", {
      CitaPersonaID: citaPersonaID,
    });
  }
  static getCURP(
    nombres,
    primerApellido,
    segundoApellido,
    fechaNacimiento,
    estadoCorto,
    generoCorto
  ) {
    const data = {
      Nombres: nombres,
      PrimerApellido: primerApellido,
      SegundoApellido: segundoApellido,
      FechaNacimiento: fechaNacimiento,
      EstadoCorto: estadoCorto,
      GeneroCorto: generoCorto,
    };
    return apiPost("/utilidades/CURP", data);
  }
  static crearMuestra(datos) {
    return apiPost("/muestras/Crear", datos);
  }
  static getMuestra(muestraID) {
    return apiPost("/muestras/info/Muestra", { MuestraID: muestraID });
  }
  static actualizarMuestra(datosMuestra) {
    return apiPost("/muestras/Actualizar", datosMuestra);
  }
  static validarCodigoBarras(codigoBarras) {
    const data = {
      Codigo: codigoBarras,
    };
    return apiPost("/muestras/ValidarCodigo", data);
  }
  static procesarCargaManual(data) {
    return apiPost("/muestras/ProcesarCargaManual", data);
  }
}
